// src/components/AccountCreation/Stepper.js
import React from 'react';
import { CheckIcon } from './Icons';

const Stepper = ({ currentStep, steps }) => {
    return (
        <div className="stepper-wrapper">
            {steps.map((step, index) => {
                const stepNumber = index + 1;
                const isActive = stepNumber === currentStep;
                const isCompleted = stepNumber < currentStep;
                let stepClass = "stepper-item";
                if (isActive) stepClass += " active";
                if (isCompleted) stepClass += " completed";
                return (
                    <div className={stepClass} key={index}>
                        <div className="step-counter">{isCompleted ? <CheckIcon /> : stepNumber}</div>
                        <div className="step-name">{step}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default Stepper;
